'use client';

import { useEffect } from 'react';

const STICKY_CTA_DISMISSED_KEY = 'stickyCtaDismissed';

/**
 * This logic was added for Safari since at back forward navigation Safari restores the page from the cache.
 */
export function StickyCtaBfcacheSync(): null {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        function onPageShow(event: PageTransitionEvent): void {
            if (event.persisted) {
                sessionStorage.removeItem(STICKY_CTA_DISMISSED_KEY);
                document.body.classList.remove('stickyBarStick');
            }
        }

        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, []);

    return null;
}
